
































































import { Component, Vue } from 'vue-property-decorator';
import BaseComponent from '../../../core/base.component';
import DeliveryFounderConsultService from '../../../services/delivery-founder-consult.service';
import { Pagination, PaginatedResponse } from '../../../common';
import {
  DeliveryFounderConsultListDto,
  DeliveryFounderConsultDto,
} from '@/dto';
import { SPACE_TYPE, FOUNDER_CONSULT } from '@/services/shared';

import { getStatusColor } from '../../../core/utils/status-color.util';

@Component({
  name: 'DashboardFounderConsultList',
})
export default class DashboardFounderConsultList extends BaseComponent {
  private founderConsultList: DeliveryFounderConsultDto[] = [];
  private founderConsultListCount = null;
  private pagination = new Pagination();
  private founderConsultListDto = new DeliveryFounderConsultListDto();
  private dataLoading = false;

  // get status color
  getStatusColor(status: FOUNDER_CONSULT) {
    return getStatusColor(status);
  }

  //TODO:  need to refactor base service
  getDashboardList() {
    this.dataLoading = true;
    this.pagination.limit = 5;
    DeliveryFounderConsultService.findAll(
      this.founderConsultListDto,
      this.pagination,
    ).subscribe(res => {
      this.dataLoading = false;
      this.founderConsultList = res.data.items;
      this.founderConsultListCount = res.data.totalCount;
    });
  }

  findOne(consolutNo) {
    this.$router.push(`/delivery-founder-consult/${consolutNo}`);
  }

  mounted() {
    this.getDashboardList();
  }
}
